'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular
    .module('searchV2Module')
    .provider('searchV2Service', [function () {
        var stateParamsConfig = {
            sourceType: { value: undefined }
        };

        var searchSourcesConfig = [{
            sourceType: 'CACMEvent',
            ItemTypeID: 22,
            uniqueItemIdKey: 'CACMEventID',
            ItemCssIcon: 'fa fa-bullseye',
            title: 'CACM Events'
        }, {
            sourceType: 'CACMControl',
            ItemTypeID: 4,
            uniqueItemIdKey: 'ControlID',
            ItemCssIcon: 'fa fa-eye',
            title: 'CACM Controls'
        }, {
            sourceType: 'BusinessPlanning',
            ItemTypeID: 31,
            uniqueItemIdKey: 'PlanDeliverableID',
            ItemCssIcon: 'fa fa-eye',
            title: 'Business Plan'
        }, {
            sourceType: 'CalendarMeeting',
            ItemTypeID: 99,
            uniqueItemIdKey: 'MeetingID',
            ItemCssIcon: 'fa fa-calendar',
            title: 'Calendar Meetings'
        }, {
            sourceType: 'Procedure',
            ItemTypeID: 99,
            uniqueItemIdKey: 'ProdecureID',
            ItemCssIcon: 'fa fa-book',
            title: 'Procedures',
            maxSearchResults: 2
        }, {
            sourceType: 'BusinessUnit',
            ItemTypeID: 99,
            uniqueItemIdKey: 'BusinessUniID',
            ItemCssIcon: 'fa fa-university',
            title: 'Business Units',
            maxSearchResults: 2
        }, {
            sourceType: 'Employee',
            ItemTypeID: 99,
            uniqueItemIdKey: 'EmployeeID',
            ItemCssIcon: 'fa fa-user',
            title: 'People',
            maxSearchResults: 4
        }, {
            sourceType: 'Control',
            ItemTypeID: 4,
            uniqueItemIdKey: 'ControlID',
            ItemCssIcon: 'fa fa-eye',
            title: 'Controls',
            maxSearchResults: 2
        }, {
            sourceType: 'Risk',
            ItemTypeID: 99,
            uniqueItemIdKey: 'RiskID',
            ItemCssIcon: 'fa fa-globe',
            title: 'Risks',
            maxSearchResults: 2
        }, {
            sourceType: 'RiskEvent',
            ItemTypeID: 99,
            uniqueItemIdKey: 'RiskEventID',
            ItemCssIcon: 'fa fa-newspaper-o',
            title: 'Risk Events',
            maxSearchResults: 2
        }, {
            sourceType: 'Committee',
            ItemTypeID: 99,
            uniqueItemIdKey: 'CommitteeID',
            ItemCssIcon: 'fa fa-users',
            title: 'Committees',
            maxSearchResults: 2
        }, {
            sourceType: 'GlossaryTerm',
            ItemTypeID: 99,
            uniqueItemIdKey: 'GlossaryTermID',
            ItemCssIcon: 'fa fa-graduation-cap',
            title: 'Glossary Terms',
            maxSearchResults: 2
        }, {
            sourceType: 'CorporateRole',
            ItemTypeID: 99,
            uniqueItemIdKey: 'CommitteeID',
            ItemCssIcon: 'fa fa-tags',
            title: 'Corporate Roles'
        }, {
            sourceType: 'RecomActionPlan',
            ItemTypeID: 99,
            uniqueItemIdKey: 'RecomActionPlanID',
            ItemCssIcon: 'fa fa-cogs',
            title: 'Action Plans',
            maxSearchResults: 2
        }, {
            sourceType: 'PlanInitiative',
            ItemTypeID: 99,
            uniqueItemIdKey: 'PlanInitiativeID',
            ItemCssIcon: 'fa fa-compass',
            title: 'Plan Initiatives',
            maxSearchResults: 2
        }, {
            sourceType: 'Recommendation',
            ItemTypeID: 99,
            uniqueItemIdKey: 'RecommendationID',
            ItemCssIcon: 'fa fa-lightbulb-o',
            title: 'Recommendations',
            maxSearchResults: 2
        }, {
             sourceType: 'AuditMandate',
             ItemTypeID: 99,
             uniqueItemIdKey: 'GovernanceProcessID',
             ItemCssIcon: 'fa fa-road',
             title: 'Audit Mandates',
             maxSearchResults: 2
        },
        {
            sourceType: 'BIAProfile',
            ItemTypeID: 92,
            uniqueItemIdKey: 'BIAProfileID',
            ItemCssIcon: 'fa fa-umbrella',
            title: 'BC Analysis',
            maxSearchResults: 2
        },
	        {
	        	sourceType: 'CACMDynamicsAccountTransaction',
		        ItemTypeID: 99,
		        uniqueItemIdKey: 'ExpenseID',
		        ItemCssIcon: 'fa fa-bullseye',
		        title: 'CACM GL Expenses'
	        },
	        {
	        	sourceType: 'CACMConcurExpense',
		        ItemTypeID: 99,
		        uniqueItemIdKey: 'ExpenseID',
		        ItemCssIcon: 'fa fa-bullseye',
		        title: 'CACM CONCUR Expenses'
	        },
	        {
	        	sourceType: 'Responsibility',
	        	ItemTypeID: 83,
		        uniqueItemIdKey: 'BIAProfileID',
		        ItemCssIcon: 'fa fa-book',
		        title: 'Responsibilities',
		        maxSearchResults: 2
	        }
        ];

        var stateParamsToSourceQueryParamsTransformers = [];
        var searchResultToContextTransformers = [];

        this.setStateParamsConfig = function (stateParamsConfigToSet) {
            _.assign(stateParamsConfig, stateParamsConfigToSet);
        };

        this.getSearchStateParamsConfig = function () {
            return stateParamsConfig;
        };

        this.getSearchUrlStateParams = function () {
            var urlParams = _.keys(stateParamsConfig).join('&');

            return urlParams;
        };

        this.stateParamsToSourceQueryParamsTransformers = stateParamsToSourceQueryParamsTransformers;
        this.searchResultToContextTransformers = searchResultToContextTransformers;

        this.$get = ["$http", '$q', '$location', function ($http, $q, $location) {

            var service = {};
            service.searchCtxt = {};

            var initSearchSources;

            var stateParams = {};
            var setStateParams = function (stateParamsToSet) { _.assign(stateParams, stateParamsToSet); };

            var searchItems = function (itemType, uniqueItemIdKey, queryParams) {
                var url = environment.apiUrl + '/Pilot/api/' + itemType + '/SearchV2';

                return $http
                        .get(url, { params: queryParams, ignoreError: true })
                        .then(function (response) {
                            if (response.status === 200) {
                                return response.data;
                            }
                            else {
                                return null;
                            }
                        }).catch(function (err) {
                            return null;
                        });
            };

            /**
             * Initializes and executes the search service for the provided source types and params.
             * @param searchSourceTypes {string[]} List of source types to initialize
             * @param [stateParamsToSet] {object} Params for the new search (such as q, sf, sourceType, etc.),
             *      will override the default params for the search.
             */
            service.initializeSearch = function (searchSourceTypes, stateParamsToSet) {
                if (_.isUndefined(searchSourceTypes) || _.size(searchSourceTypes) === 0) throw 'searchService: No Search Sources are specified.';

                initSearchSources = _.map(searchSourceTypes, function (sourceType) {
                    var searchSourceConfig = _.find(searchSourcesConfig, { sourceType: sourceType });
                    if (_.isUndefined(searchSourceConfig)) throw 'searchService: Search Source "' + sourceType + '" has not been configured.';

                    var searchSource = _.cloneDeep(searchSourceConfig);

                    searchSource.searchFn = function (queryParams) {

                        return searchItems(sourceType, searchSource.uniqueItemIdKey, queryParams);
                    };


                    return searchSource;
                });

                var initStateParams = _.mapValues(stateParamsConfig, function (config, param) {
                    return config.value;
                });

                return service.search(_.assignWith(initStateParams, stateParamsToSet, function (srcValue, objValue) {
                    return _.isUndefined(objValue) ? srcValue : objValue;
                }), false);
            };

            /**
             * Returns the source configurations for a given type
             *
             * @param sourceType {string} name of the source type (e.g. Control, PlanInitiative)
             * @returns {object} clone of the source config for the given type, undefined if not found
             */
            service.getSourceTypeConfig = function (sourceType) {
                return _.clone(_.find(searchSourcesConfig, { sourceType: sourceType }));
            };


            /**
             *
             * @param searchSource
             */
            service.getQueryParams = function (searchSource) {
                searchSource.queryParams = {};

                _.forEach(stateParamsToSourceQueryParamsTransformers, function (transformer) {
                    transformer(stateParams, searchSource, true);
                });

                return searchSource.queryParams;
            };

            /**
             * Triggers a search to the server
             *
             * @param stateParamsToSet {object} Params for the new search (such as q, sf, sourceType, etc.)
             * @param resetSearch {object|boolean} if provided and not exactly false, will reset all necessary
             *      parameters such as info on paging.
             */
            service.search = function (stateParamsToSet, resetSearch) {

                // Set State Params
                if (resetSearch !== false) {

                    var resetParams = _.reduce(stateParamsConfig, function (rstParms, config, param) {
                        if (_.has(config, 'resetValue')) rstParms[param] = config.resetValue;

                        return rstParms;
                    }, {});

                    stateParamsToSet = _.assign(resetParams, stateParamsToSet);
                }

                setStateParams(stateParamsToSet);

                // Build Search Promises with their query params
                var searchPromises = _.map(initSearchSources, function (searchSource) {
                    var isSourceTypeSelected = !_.isUndefined(stateParams.sourceType);

                    if (isSourceTypeSelected && stateParams.sourceType !== searchSource.sourceType) return $q.when({});

                    searchSource.queryParams = {};

                    _.forEach(stateParamsToSourceQueryParamsTransformers, function (transformer) {
                        transformer(stateParams, searchSource, isSourceTypeSelected);
                    });

                    return searchSource.searchFn(searchSource.queryParams);
                });

                // Build Search Ctxt from Search Response
                return $q.all(searchPromises)
                         .then(function (searchResponses) {
                             var sourcesWithFoundResults = _.filter(searchResponses, function (sRep) { return sRep && sRep.response && sRep.response.numFound > 0; });

                             if (sourcesWithFoundResults.length === 1) {
                                 var sourceWithResultsIdx = _.findIndex(searchResponses, function (sRep) { return sRep && sRep.response && sRep.response.numFound > 0; });
                                 stateParams.sourceType = initSearchSources[sourceWithResultsIdx].sourceType;
                             }

                             var searchCtxt = {
                                 sourceType: stateParams.sourceType,
                                 sources: _.map(initSearchSources, function (selectedSearchSource, sourceIdx) {
                                     var source = _.cloneDeep(selectedSearchSource);
                                     source.searchResponse = searchResponses[sourceIdx];

                                     return source;
                                 })
                             };

                             var isSourceTypeSelected = !_.isUndefined(stateParams.sourceType);

                             _.forEach(searchResultToContextTransformers, function (transformer) {
                                 transformer(searchCtxt, stateParams, isSourceTypeSelected);
                             });

                             // Update Url State Params
                             $location.search(stateParams).replace();

                             return searchCtxt;
                         });
            };

            return service;
        }];
    }]);
